import React, { useContext, useEffect } from 'react'
import { LinearProgress } from '@mui/material'
import { AppContext } from '../contexts/AppContextProvider'
import useScreenFlow from '../hooks/useScreenFlow'

const ProgressBar = () => {
    const { progress, setProgress } = useContext(AppContext)
    const { calculateProgress } = useScreenFlow()

    useEffect(() => {
        setProgress(calculateProgress())
    }, [setProgress, calculateProgress])

    return (
        <LinearProgress
            variant='determinate'
            value={progress}
            style={{
                marginBottom: '2rem',
                height: 20,
            }}
        />
    )
}

export default ProgressBar
